<template>
	<div>
		<el-tabs type="card" @tab-click="handleClick" v-model="tagValue">
			<el-tab-pane label="京东填报信息" name="jd">
				<TaxationFormList v-if="tagValue=='jd'" @success="onSuccess" :value="tagValue"></TaxationFormList>
			</el-tab-pane>
		<!-- 	<el-tab-pane label="抖音填报信息" name="dy">
				<DyTaxationFormList v-if="tagValue=='dy'" :value="tagValue"></DyTaxationFormList>
			</el-tab-pane> -->
		</el-tabs>
	</div>
</template>

<script>
	import TaxationFormList from "../taxationFormList/taxationFormList";
	import DyTaxationFormList from "../dyTaxationFormList/dyTaxationFormList.vue";
	export default {
		components: {
			TaxationFormList, 
			DyTaxationFormList
		},
		data() {
			return {
				tagValue: 'jd',
			}
		},
		methods: {
			onSuccess() {

			},
			handleClick(tab, event) {}
		},
		// created() {
		// 	let userId = localStorage.getItem('userId');
		// 	if (userId == null) {
		// 		this.$router.push('/home')
		// 		return false
		// 	} else if (this.$route.query.id != userId) {
		// 		this.$router.push('/home')
		// 		return false
		// 	}
		// }
	}
</script>

<style scoped>
</style>